import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { CustomHttp, ConfigServerService } from '../../../core';
import { Pais } from '../pais';

@Injectable({
    providedIn: 'root'
})
export class PaisSearchesHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/pais`;
    }

    /** Procura o pais Brasil */
    findBrasil(): Observable<Pais> {
        return this.customHttp.get<Pais>(`${this.pathApi}/0/brasil`);
    }
}
